import CheckoutPauseBanner from './CheckoutPauseBanner';

export default CheckoutPauseBanner;
